import React from 'react'

import {URL_HELP_CENTER_URL} from '@constant/url'
import {useTranslation} from '@lib/intl/useTranslations'

import Link from 'next/link'
import WizTextButton from '@component/buttons/WizTextButton'

import IconNewWindow from '@svg/common/ic_new_window.svg'

interface IProps {
    className?: string
}

const HelpCenterText: React.FC<IProps> = ({className}) => {
    const t = useTranslation()
    return (
        <Link href={URL_HELP_CENTER_URL} target={'_blank'} className={className}>
            <WizTextButton
                className={`gap-x-[5px]`}
                textClassName={'text-body3'}
                text={t('common.help.center.text')}
                renderRightIcon={<IconNewWindow width={12} className={'fill-gray02 dark:fill-dark_gray02'} />}
            />
        </Link>
    )
}

export default HelpCenterText
